import { Title, SimpleGrid, Text, Grid, rem } from "@mantine/core";
import {
  IconAdjustments,
  IconHeartbeat,
  IconMoon,
  IconHeart,
  IconSettings,
  IconBrain,
} from "@tabler/icons-react";
import classes from "./focus.module.scss";

const features = [
  {
    icon: IconBrain,
    title: "Mindset",
    description:
      "Tanke → Følelse → Handling → Resultat. Over 90 % av daglige tanker er de samme som dagen før, noe som betyr at de fleste valgene vi tar styres av ubevisste automatismer. Helhetlig coaching handler om å gjøre det ubevisste bevisst — slik at du kan erstatte vaner som holder deg tilbake med nye som driver deg fremover.",
  },
  {
    icon: IconMoon,
    title: "Søvn",
    description:
      "Søvn er det mest undervurderte verktøyet for god helse. Uten tilstrekkelig lengde og kvalitet vil effekten av kosthold og trening reduseres kraftig. Kosthold, trening, stressnivå, koffein, lysmiljø og romtemperatur påvirker alle søvnkvaliteten din — og dette jobber vi systematisk med fra dag én.",
  },
  {
    icon: IconHeartbeat,
    title: "Generell helse",
    description:
      "Fokuserer du kun på kalorier, overser du det som faktisk betyr mest: ingredienskvalitet, næringstetthet og prosesseringsgrad. Ultraprosessert mat kan forstyrre hormoner, tarmflora og betennelsesnivå — selv ved «riktig» kaloriinntak. Vi ser på maten din som et verktøy for helse, ikke bare energi inn og ut.",
  },
  {
    icon: IconAdjustments,
    title: "Små endringer",
    description:
      "Dramatiske tiltak skaper sjelden varige resultater. Det er de små, konsekvente hverdagsvalgene — som måltidstidspunkt, spisetempo og hva du gjør rett etter å ha spist — som utgjør den reelle forskjellen over tid. Disse justeringene er enkle å gjennomføre og gir overraskende store effekter uten at det krever viljestyrke.",
  },
  {
    icon: IconHeart,
    title: "Mental helse",
    description:
      "Koblingen mellom tarmen og hjernen er godt vitenskapelig dokumentert. Ultraprosessert mat og dårlige søvnvaner påvirker produksjonen av serotonin og dopamin — kroppens egne «lykkehormoner». Ved å optimalisere kosthold og livsstil kan mange oppleve tydelig bedring i humør, fokus og indre ro uten andre tiltak.",
  },
  {
    icon: IconSettings,
    title: "Andre faktorer",
    description:
      "Utover de klassiske helsefaktorene finnes det elementer de fleste aldri har vurdert: inneklimakvalitet, kjemikalier i hverdagsprodukter, vannkvalitet og EMF-eksponering fra elektronikk. Disse bidrar mer til kroppens totale belastning enn de fleste er klar over, og er viktige brikker i det helhetlige bildet.",
  },
];

export function FeaturesTitle() {
  const items = features.map((feature) => (
    <div key={feature.title} className={classes.feature}>
      <div className={classes.iconWrapper}>
        <feature.icon
          style={{ width: rem(28), height: rem(28) }}
          stroke={1.5}
          aria-hidden="true"
          className={classes.icon}
        />
      </div>
      <Text fz="lg" fw={700} className={classes.featureTitle}>
        {feature.title}
      </Text>
      <Text c="white" fz="sm" className={classes.featureDescription}>
        {feature.description}
      </Text>
    </div>
  ));

  return (
    <div className={classes.wrapper}>
      <Grid gutter={80} justify="center">
        <Grid.Col span={12} style={{ textAlign: "center" }}>
          <span className={classes.label}>Min filosofi</span>
          <Title className={classes.title} order={2}>
            Helse er mer enn kalorier inn og ut
          </Title>
          <Text className={classes.introText}>
            Kroppen er et komplekst system, ikke et enkelt regnestykke. Langvarig
            kalorirestriksjon kan gi lavere forbrenning, hormonell ubalanse og
            kronisk energimangel — og studier viser at 80–95 % av de som går ned
            i vekt sklir tilbake innen 2–5 år. Derfor bygger jeg bærekraftige
            rutiner som støtter helsen på alle plan, slik at resultatene faktisk
            blir varige.
          </Text>
        </Grid.Col>
        <Grid.Col span={12}>
          <SimpleGrid cols={{ base: 1, md: 2, lg: 3 }} spacing={32}>
            {items}
          </SimpleGrid>
        </Grid.Col>
      </Grid>
    </div>
  );
}
